// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4533":"theme-selector-cermati-component","7229":"tandCdialog-component"}[chunkId] + "." + {"4533":"4bb4c313","7229":"3c829a7c"}[chunkId] + ".chunk.css";
};